import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { UtenteDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class UtenteApiClient extends BaseCRUDApiClient<UtenteDto> {
  baseUrl = this.config.apiEndpoint + '/utente';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  resetMFA(id: number) {
    return this.http.post<UtenteDto>(this.baseUrl + '/reset-mfa', {
      id: id,
    });
  }
}
